import appReducers from '../reducer/app';
import iamReducers from "../reducer/iam";
import contentReducers from "../reducer/content";
import memberReducers from "../reducer/member";
import satisfactionSurveyReducers from "../reducer/satisfactionSurvey";
import certificateDownloadReducers from "../reducer/certificateDownload";
import utilReducers from "../reducer/util";
import enrollmentReducers from "../reducer/enrollment";
import lecturerReducers from "../reducer/lecturer";
import onlineTestReducers from "../reducer/onlinTest";

const rootReducer = {
    ...appReducers,
    ...iamReducers,
    ...contentReducers,
    ...memberReducers,
    ...satisfactionSurveyReducers,
    ...certificateDownloadReducers,
    ...utilReducers,
    ...enrollmentReducers,
    ...lecturerReducers,
    ...onlineTestReducers,
};

export default rootReducer;
